import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  TextField,
  Button,
  FormControl,
  FormLabel,
  Typography,
  Stack,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  CircularProgress,
} from "@mui/material";
import {
  fetchBookwisePayModeReport,
  fetchBookwiseReport,
  fetchBookwisePayModeWiseReport,
} from "../../../redux/reportBookwiseSlice";
import { fetchDropdownOptions } from "../../../redux/dropdownoptionsSlice";
import BookwiseTable from "./ReportTable";
import {logger} from "../../../utils/logger";

const BookwiseReportFilterForm = () => {
  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [payMode, setPayMode] = useState("All");
  const [addPayMode, setAddPayMode] = useState(false);
  const dispatch = useDispatch();
  const [tableType, setTableType] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { data = {} } = useSelector((state) => state.dropdownOptions);
  const {user, role} = useSelector((state) => state.auth);

  useEffect(() => {
    if (!data.paymode.length) {
      dispatch(fetchDropdownOptions("paymode"));
    }
  }, [dispatch, data.paymode.length]);

  const handleFilter = async () => {
    try {
      if (!from || !to) {
        logger.warn("In Breakup of Paymode, From and TO book nnumber missing",{username:user?.username, role:role});
        return null;
      }
      setIsFilterClicked(true);
      setLoading(true);
      setTableData([]);
      setTableType(null);

      if (from && to && !addPayMode) {
        const response = await dispatch(fetchBookwiseReport({ from, to }));
        if (response) {
          setTableType("bookwise");
          setTableData(response.payload);
          logger.info("Filter applied successfully", {
            filterType: "Bookwise",
            username: user?.username,
            role:role,
          })
        } else {
          setTableData([]);
          setTableType(null);
          logger.error("Filter failed (no response payload)",{
            filterType:"Bookwise",
            username: user?.username,
            role:role
          })
        }
      } else if (from && to && addPayMode && payMode === "All") {
         const response = await dispatch(
          fetchBookwisePayModeReport({ from, to })
        );

        if (response && response.payload) {
          setTableType("bookwisePayMode");
          setTableData(response.payload);
          logger.info("Filter applied successfully",{
            filterType:"Bookwise Paymode",
            username:user?.username,
            role:role,
          });
        } else {
          setTableData([]);
          setTableType(null);
          logger.error("Filter failed (no response payload)",{
            filterType:"Bookwise Paymode",
            username: user?.username,
            role:role
          })
        }
      } else if (from && to && addPayMode && payMode !== "All") {
        const response = await dispatch(
          fetchBookwisePayModeWiseReport({ from, to, payMode })
        );

        if (response && response.payload) {
          setTableType("bookwisePayMode");
          setTableData(response.payload);
           logger.info("Filter applied successfully",{
            filterType:"Bookwise Paymode All",
            username:user?.username,
            role:role,
          });
        } else {
          setTableData([]);
          setTableType(null);
            logger.error("Filter failed (no response payload)",{
            filterType:"Bookwise Paymode All",
            username: user?.username,
            role:role
          })
        }
      }
    } catch (err) {
      logger.error("Error occur during Filter data", {error:err});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {},  [tableData, tableType]);
  return (
    <>
      <Box 
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2,
          marginBottom: 2,
        }}
      >
        <TextField
          label="From Book No"
          value={from}
           onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z0-9]*$/.test(value)) {
                  setFrom(value);
                }
              }}
          size="small"
        />
        <TextField
          label="To Book No"
          value={to}
           onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z0-9]*$/.test(value)) {
                  setTo(value);
                }
              }}
          size="small"
        />
        <FormControl
          component="fieldset"
          size="small"
          sx={{ minWidth: 120, pl: 1 }}
        >
          <FormLabel component="legend">Add Pay Mode</FormLabel>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography>No</Typography>
            <Switch
              label="Add Pay Mode"
              name="addPayMode"
              value={addPayMode}
              sx={{ marginTop: 3 }}
              onChange={(e) => setAddPayMode(e.target.checked)}
            />
            <Typography>Yes</Typography>
          </Stack>
        </FormControl>

        {addPayMode ? (
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Pay Mode</InputLabel>
            <Select
              label="Pay Mode"
              name="payMode"
              value={payMode}
              onChange={(e) => setPayMode(e.target.value)}
            >
              {(data.paymode || []).map((opt) => (
                <MenuItem key={opt._id} value={opt.value}>
                  {opt.value}
                </MenuItem>
              ))}
              <MenuItem value="All">All</MenuItem>
            </Select>
          </FormControl>
        ) : null}

        <Button variant="contained" color="primary" onClick={handleFilter}>
          Apply Filter
        </Button>
      </Box>
    {loading ? (
  <Box textAlign="center" mt={2}>
    <CircularProgress />
  </Box>
) : tableType && tableData.report.length > 0 ? (
  <BookwiseTable type={tableType} data={tableData}/>
) : (
  isFilterClicked && (
    <Box textAlign="center" mt={2} fontWeight="bold" color="black">
      No Reports Found
    </Box>
  )
)}

    </>
  );
};
export default BookwiseReportFilterForm;
